import React, { useEffect, useState, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify';
import CompanyService from '../../services/CompanyService';
import AppSidebar from '../../components/AppSidebar';
import AppHeader from '../../components/AppHeader';
import PageHeader from '../../components/PageHeader';
import RecentActivity from '../../components/RecentActivity';

const ViewCompany = () => {
    const { id } = useParams();
    const [companyData, setCompanyData] = useState({});
    const type = "company";


    const fetchCompanyDetails = useCallback(async () => {
        try {
            const response = await CompanyService.get(id);
            if (response.status === 200) {
                setCompanyData(response?.data?.data);
            }
        } catch (error) {
            toast.error(error.message || 'An error occurred');
        }
    }, [id]);

    useEffect(() => {
        fetchCompanyDetails();
    }, [fetchCompanyDetails]);
    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader />
                <div className="container-fluid">
                    <div className="row">
                        <PageHeader
                            title='Company'
                            button_label1="Back"
                            link_to1="/user"
                            className1="btn btn-primary btn-sm"
                        />
                        <div className="container card p-3">
                            <div className="row">
                                <div className="col-12 col-md-12 col-lg-8 mb-4">
                                    <div className="card p-4">
                                        <p className="d-flex justify-content-between"><strong>Company Name:</strong> {companyData?.name}</p>
                                        <p className="d-flex justify-content-between"><strong>GST Number:</strong> {companyData?.gst_no}</p>
                                        <p className="d-flex justify-content-between"><strong>Phone:</strong> {companyData?.phone}</p>
                                        <p className="d-flex justify-content-between"><strong>Website:</strong>{companyData?.website}</p>
                                        <p className="d-flex justify-content-between"><strong>Groups:</strong> {companyData?.groups}</p>
                                        <p className="d-flex justify-content-between"><strong>Currency:</strong> {companyData?.currency}</p>
                                        <p className="d-flex justify-content-between"><strong>Address:</strong> {companyData?.address}</p>
                                        <p className="d-flex justify-content-between"><strong>City:</strong> {companyData?.city}</p>
                                        <p className="d-flex justify-content-between"><strong>State:</strong> {companyData?.state}</p>
                                        <p className="d-flex justify-content-between"><strong>Zipcode:</strong> {companyData?.zipCode}</p>
                                        <p className="d-flex justify-content-between"><strong>Country:</strong> {companyData?.country}</p>
                                    </div>
                                </div>
                                <div className="col-12 col-md-12 col-lg-4 mb-4">
                                    <RecentActivity type={type} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer />
        </>
    )
}

export default ViewCompany